export default __webpack_public_path__ + "static/media/SWT1840.34I-40895_-24201_0.04d3da51.jpg";